module.exports = __webpack_public_path__ + "img/ipad-dark.e2a94180.png";